import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import VideoIcon from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import LockIcon from '@wix/da-ds/pkg/Icons/24x24/Lock';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { ThemeOverride, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import PromoBadgeWithTooltip from '../../../../PromoBadgeWithTooltip';
import { useDeviationViewContext } from '../../../../Context';
import { getDeviationType, isDeviationPixelArt, isFileLargerThanSize, scaleToSize } from '../../../_helpers';
import { DeviationTypes } from '../../../../types/deviation';
import { usePrimaryTier } from '../../../../Tier/PrimaryTierContext';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import MediaService from '../../../../utils/DeviationMediaService';
import SubscribeButton from '../../../../Button/SubscribeButton';
import ImageContent from '../../Image/ImageContent';
import ConditionalWrapper from '../../../../ConditionalWrapper';
import { formatPrice } from '../../../TierProductCardDumb/utils';
import s from './SubPaywall.scss';
const SubPaywall = ({ width, height, deviation, showImage = false, isStatusArtStage = false, className })=>{
    var _deviation_author, _deviation, _tier_tier, _size, _size1;
    const { t } = useTranslation();
    const newSubscribeButtons = useFlag('subscribe_btns');
    const isMobile = useContext(MobileContext);
    const { isFullscreen } = useDeviationViewContext();
    const tier = usePrimaryTier(deviation);
    const { isSubscribedButBlocked } = useSubscriptionTier(deviation);
    const zoomedFile = MediaService.getLargestFullview(deviation);
    const isHuge = !!zoomedFile && isFileLargerThanSize(zoomedFile, width, height);
    const file = isHuge ? MediaService.getFullviewForSize(deviation, width, height) : zoomedFile;
    if (!file || !tier) {
        return null;
    }
    const size = scaleToSize(file, {
        width,
        height
    });
    const isPixel = isDeviationPixelArt(deviation);
    const isFilm = getDeviationType(deviation) === DeviationTypes.FILM;
    const bodylocaleKey = getBodyLocaleKey(isMobile, isSubscribedButBlocked);
    const bodyText = t(bodylocaleKey, {
        username: (_deviation = deviation) === null || _deviation === void 0 ? void 0 : (_deviation_author = _deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.username,
        price: formatPrice((_tier_tier = tier.tier) === null || _tier_tier === void 0 ? void 0 : _tier_tier.dollarPrice)
    });
    var _deviation_title;
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames(s['root'], !showImage && s['no-image'], isStatusArtStage && s['status'], isFullscreen && s['fullscreen'], className),
        style: {
            width,
            height
        }
    }, showImage && /*#__PURE__*/ React.createElement("div", {
        className: s['overlay']
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(ImageContent, {
        key: file.src,
        width: (_size = size) === null || _size === void 0 ? void 0 : _size.width,
        height: (_size1 = size) === null || _size1 === void 0 ? void 0 : _size1.height,
        file: file,
        alt: (_deviation_title = deviation.title) !== null && _deviation_title !== void 0 ? _deviation_title : '',
        isPixel: isPixel,
        canZoom: false,
        onZoom: ()=>{}
    })), isFilm && /*#__PURE__*/ React.createElement(VideoIcon, {
        className: s['video-icon']
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['centered'],
        style: size
    }, /*#__PURE__*/ React.createElement(ConditionalWrapper, {
        condition: showImage,
        wrap: (children)=>/*#__PURE__*/ React.createElement(ThemeOverride, {
                theme: ThemeOptions.DARK
            }, children)
    }, newSubscribeButtons ? /*#__PURE__*/ React.createElement(LockIcon, null) : /*#__PURE__*/ React.createElement(PromoBadgeWithTooltip, {
        badgeType: "tier",
        size: 40,
        isLocked: true,
        className: s['icon']
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, t(isSubscribedButBlocked ? 'deviationview.subpaywall.title.subscribedButBlocked' : 'deviationview.subpaywall.title')), /*#__PURE__*/ React.createElement("div", {
        className: s['main']
    }, bodyText), !isSubscribedButBlocked && /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            referral_info: ReferralType.CONTENT_PAGE
        }
    }, /*#__PURE__*/ React.createElement(SubscribeButton, {
        tier: tier
    }))));
};
SubPaywall.displayName = 'SubPaywall';
export default SubPaywall;
function getBodyLocaleKey(isMobile = false, isSubscribedButBlocked = false) {
    let bodyTextlocaleKey = 'deviationview.subpaywall.body';
    if (isSubscribedButBlocked) {
        // deviationview.subpaywall.body.subscribedButBlocked
        bodyTextlocaleKey += '.subscribedButBlocked';
    }
    if (isMobile) {
        // deviationview.subpaywall.body.mobile
        // deviationview.subpaywall.body.subscribedButBlocked.mobile
        bodyTextlocaleKey += '.mobile';
    }
    return bodyTextlocaleKey;
}
